import React, { useContext, useEffect } from 'react'
import { PageMeta } from 'components/Layout/Page'
import { Box, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { TaskBar, List, ThemeProvider } from '@react95/core'
import {
  Awfxex32Info,
  Mspaint,
  Computer,
  Progman21,
  Gcdef100,
  Mailnews15,
  Network2,
  Lock,
  Wab321017,
  Issue,
  FileText,
  Progman39,
  Inetcpl1318,
} from '@react95/icons'
import { useTranslation } from 'contexts/Localization'
import { AutoRow } from 'components/Layout/Row'
import { MerchRegionContext } from 'Providers'
import { AutoColumn } from 'components/Layout/Column'
import Windoge2Modal from './components/Modals/Windoge2'
import SwapOverviewModal from './components/Modals/SwapModal'
import NFTCreatorModal from './components/Modals/NFTCreatorModal'
import InfluencersModal from './components/Modals/InfluencersModal'
import AuditsModal from './components/Modals/AuditsModal'
import HowToBuyModal from './components/Modals/HowToBuyModal'
import HelpModal from './components/Modals/HelpModal'
import LegalDisclaimerModal from './components/Modals/LegalDisclaimerModal'
import GamesModal from './components/Modals/GamesModal'
import RewardsModal from './components/Modals/RewardsModal'
import MerchModal from './components/Modals/MerchModal'
import MerchModalStore from './components/Modals/MerchModalStore'
import MigrationModal from './components/Modals/MigrationModal'
import MerchModalStoreEur from './components/Modals/MerchModalStoreEur'
import ReflectionsModal from './components/Modals/ReflectionsModal'

export default function Roadmap() {
  const { t } = useTranslation()
  const { isMobile } = useMatchBreakpoints()
  const [websiteInfo, toggleWebsiteInfo] = React.useState(true)
  const [howToBuy, toggleHowToBuy] = React.useState(false)
  const [help, toggleHelp] = React.useState(false)
  const [nftCreator, toggleNFTCreator] = React.useState(false)
  const [windogeSwap, toggleWindogeSwap] = React.useState(false)
  const [influencers, toggleInfluencers] = React.useState(false)
  const [reflections, toggleReflections] = React.useState(false)
  const [migration, toggleMigration] = React.useState(false)
  const [games, toggleGames] = React.useState(false)
  const [audits, toggleAudits] = React.useState(false)
  const [legalDisclaimer, toggleLegalDisclaimer] = React.useState(false)
  const [rewards, toggleRewards] = React.useState(false)
  const [merch, toggleMerch] = React.useState(false)
  const [showStore, toggleShowStore] = React.useState(false)
  const { region, setRegion } = useContext(MerchRegionContext)

  const closeWebsiteInfo = () => toggleWebsiteInfo(false)
  const closeNFTCreator = () => toggleNFTCreator(false)
  const closeWindogeSwap = () => toggleWindogeSwap(false)
  const closeInfluencers = () => toggleInfluencers(false)
  const closeAudits = () => toggleAudits(false)
  const closeHowToBuy = () => toggleHowToBuy(false)
  const closeHelp = () => toggleHelp(false)
  const closeDisclaimer = () => toggleLegalDisclaimer(false)
  const closeGames = () => toggleGames(false)
  const closeRewards = () => toggleRewards(false)
  const closeMerch = () => toggleMerch(false)
  const closeMigration = () => toggleMigration(false)
  const closeReflections = () => toggleReflections(false)

  useEffect(() => (!region ? toggleShowStore(false) : toggleShowStore(true)), [region])

  const bulletStyle: any = {
    marginTop: '16px',
    marginBottom: '16px',
    fontSize: '18px',
  }

  const iconContainerStyle: any = {
    width: '104px',
    textAlign: 'center',
    marginLeft: '16px',
    marginTop: '16px',
    marginBottom: '16px',
    cursor: 'pointer',
  }
  const iconStyle: any = { height: '52px', width: '52px' }
  const modalFrameStyle: any = {
    minWidth: '90%',
    minHeight: '90%',
    backgroundColor: 'white',
    overflowY: 'scroll',
    maxHeight: isMobile ? '430px' : '530px',
    padding: '8px',
  }
  const modalStyle: any = {
    margin: '16px',
    height: '80%',
    width: '80%',
    minWidth: '80%',
    minHeight: isMobile ? '400px' : '600px',
    maxWidth: '400px',
    maxHeight: isMobile ? '500px' : '500px',
  }

  return (
    <>
      <style>
        {` 
          body {
            background-color: #008080;
            background-image: url(https://uploads-ssl.webflow.com/618355b75eeec9b5cc079e5c/61934152bfe13650b9148d21_DesktopBG.jpeg);
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-attachment: fixed;
          }
      `}
      </style>

      <script>
        {region === 'usa'
          ? `var spread_shop_config = {
              shopName: 'windoge95',
              locale: 'us_US',
              prefix: 'Merchandise - Windoge95',
              baseId: 'myShop'
            };`
          : `var spread_shop_config = {
              shopName: 'windoge95',
              locale: 'en_NL',
              prefix: 'https://windoge95.myspreadshop.nl/',
              baseId: 'myShop'
            };`}
      </script>

      <ThemeProvider>
        <PageMeta />
        {websiteInfo && (
          <Windoge2Modal
            close={closeWebsiteInfo}
            modalStyle={modalStyle}
            frameStyle={modalFrameStyle}
            bulletStyle={bulletStyle}
          />
        )}
        {nftCreator && <NFTCreatorModal close={closeNFTCreator} modalStyle={modalStyle} frameStyle={modalFrameStyle} />}

        {windogeSwap && (
          <SwapOverviewModal close={closeWindogeSwap} modalStyle={modalStyle} frameStyle={modalFrameStyle} />
        )}
        {influencers && (
          <InfluencersModal
            close={closeInfluencers}
            modalStyle={modalStyle}
            frameStyle={modalFrameStyle}
            bulletStyle={bulletStyle}
          />
        )}
        {games && <GamesModal close={closeGames} modalStyle={modalStyle} frameStyle={modalFrameStyle} />}
        {reflections && (
          <ReflectionsModal close={closeReflections} modalStyle={modalStyle} frameStyle={modalFrameStyle} />
        )}
        {migration && <MigrationModal close={closeMigration} modalStyle={modalStyle} frameStyle={modalFrameStyle} />}
        {rewards && <RewardsModal close={closeRewards} modalStyle={modalStyle} frameStyle={modalFrameStyle} />}
        {audits && (
          <AuditsModal
            close={closeAudits}
            modalStyle={modalStyle}
            frameStyle={modalFrameStyle}
            iconStyle={iconStyle}
            iconContainerStyle={iconContainerStyle}
          />
        )}
        {merch && (
          <MerchModal close={closeMerch} modalStyle={modalStyle} frameStyle={modalFrameStyle} iconStyle={iconStyle} />
        )}
        {showStore &&
          (region === 'usa' ? (
            <MerchModalStore close={() => setRegion(null)} />
          ) : (
            <MerchModalStoreEur close={() => setRegion(null)} />
          ))}
        {howToBuy && (
          <HowToBuyModal
            close={closeHowToBuy}
            modalStyle={modalStyle}
            frameStyle={modalFrameStyle}
            bulletStyle={bulletStyle}
          />
        )}
        {help && (
          <HelpModal
            close={closeHelp}
            modalStyle={modalStyle}
            frameStyle={modalFrameStyle}
            iconStyle={iconStyle}
            iconContainerStyle={iconContainerStyle}
            toggleHowToBuy={toggleHowToBuy}
          />
        )}
        {legalDisclaimer && (
          <LegalDisclaimerModal close={closeDisclaimer} modalStyle={modalStyle} frameStyle={modalFrameStyle} />
        )}

        <AutoRow align="flex-start">
          <AutoColumn justify="start">
            <Box style={iconContainerStyle} onClick={() => toggleWebsiteInfo(true)}>
              <Computer style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Windoge95 Version 2')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleNFTCreator(true)}>
              <Mspaint style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('NFT Creator')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleGames(true)}>
              <Gcdef100 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Arcade')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleMerch(true)}>
              <Wab321017 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Merchandise')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleHowToBuy(true)}>
              <Awfxex32Info style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('How to Buy')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleReflections(true)}>
              <Inetcpl1318 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Check Reflections')}
              </Text>
            </Box>
          </AutoColumn>
          <AutoColumn justify="start" style={{ marginLeft: '16px' }}>
            <Box style={iconContainerStyle} onClick={() => toggleWindogeSwap(true)}>
              <Network2 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('WindogeSwap')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleInfluencers(true)}>
              <Progman21 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Influencers')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleAudits(true)}>
              <Lock style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Audits')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleMigration(true)}>
              <Progman39 style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Migrate to V2')}
              </Text>
            </Box>
            <Box style={iconContainerStyle} onClick={() => toggleHelp(true)}>
              <Issue style={iconStyle} />
              <Text color="white" fontSize="20px" textAlign="center">
                {t('Help')}
              </Text>
            </Box>
          </AutoColumn>
        </AutoRow>

        <TaskBar
          list={
            <List>
              <List.Item icon={<Computer variant="32x32_4" />} onClick={() => toggleWebsiteInfo(true)}>
                Windoge95 Version 2
              </List.Item>
              <List.Item icon={<Mspaint variant="32x32_4" />} onClick={() => toggleNFTCreator(true)}>
                NFT Creator
              </List.Item>
              <List.Item icon={<Gcdef100 variant="32x32_4" />} onClick={() => toggleGames(true)}>
                Arcade
              </List.Item>
              <List.Item icon={<Network2 variant="32x32_4" />} onClick={() => toggleWindogeSwap(true)}>
                WindogeSwap
              </List.Item>
              <List.Item icon={<Progman21 variant="32x32_4" />} onClick={() => toggleInfluencers(true)}>
                Influencers
              </List.Item>
              <List.Item icon={<Lock variant="32x32_4" />} onClick={() => toggleAudits(true)}>
                Audits
              </List.Item>
              <a href="/rewards" target="_blank">
                <List.Item icon={<Mailnews15 variant="32x32_4" />}>Rewards</List.Item>
              </a>
              <a href="https://www.windoge95.com/merchandise" target="_blank" rel="noreferrer">
                <List.Item icon={<Wab321017 variant="32x32_4" />}>Merchandise</List.Item>
              </a>
              <List.Item icon={<FileText variant="32x32_4" />} onClick={() => toggleLegalDisclaimer(true)}>
                Legal Disclaimer
              </List.Item>
            </List>
          }
        />
      </ThemeProvider>
    </>
  )
}
